"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gen_add_monsters = void 0;
var diveDebug_sidecar_1 = require("@dive/debug/diveDebug-sidecar");
var diveObjects_sidecar_1 = require("@dive/entities/diveObjects-sidecar");
var diveObjectsData_1 = require("@dive/entities/diveObjectsData");
var diveObjectsData_sidecar_1 = require("@dive/entities/diveObjectsData-sidecar");
var diveTileData_1 = require("@dive/tilemap/diveTileData");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var distanceUtil_sidecar_1 = require("@lib/distanceUtil-sidecar");
var diveCrew_hero_data_1 = require("@voyage/crew/diveCrew_hero_data");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var diveMessage_alterEntity_1 = require("@voyage/multi/diveMessage_alterEntity");
var diveMessage_alterEntity_sidecar_1 = require("@voyage/multi/diveMessage_alterEntity-sidecar");
var genUtils_sidecar_1 = require("../common/genUtils-sidecar");
function gen_add_monsters(info) {
    var rnd, stairUp, isHost, doCreateStuff, numNewHeroes, numNewPets, spots8, possibleSpots, existingHeroes, existingPets, deadHeroes, getNextSpot, c, c, _a, oi, oj, c, _b, oi, oj, heroIdx, heroSubtypes, heroWeapons, _c, oi, oj, heroType, heroWeapon, cr, weapData, weap, _d, oi, oj, cr, enemySubtypes, enemiesMultiplier, numEnemies, iAttempts, freeSpots, freeSpot, distFromSafeZone, cr;
    return __generator(this, function (_e) {
        rnd = info.rnd;
        stairUp = diveTilemap_sidecar_1.diveTilemap.findFirstTile(function (tile) {
            return tile.tile1.type === diveTileData_1.EDiveTile.StairsUp;
        });
        isHost = true;
        doCreateStuff = true && isHost;
        numNewHeroes = 0;
        numNewPets = 0;
        if (info.options.isStartingLevel) {
            console.log('!! is starting level');
            numNewHeroes = diveDebug_sidecar_1.diveDebug.debug_numHeroes;
            numNewPets = diveDebug_sidecar_1.diveDebug.debug_numPets;
        }
        else {
            console.log('!! is new level');
        }
        spots8 = [
            [-1, 0],
            [1, 0],
            [0, -1],
            [0, 1],
            [-1, -1],
            [-1, 1],
            [1, -1],
            [1, 1],
        ];
        possibleSpots = rnd.shuffle(spots8);
        if (stairUp) {
            existingHeroes = diveCrew_sidecar_1.diveCrew.getAllFiltered(function (c) { return c.type === diveCrew_1.EVoyageCrewType.Hero && (c.isDownStairs || false); });
            existingPets = diveCrew_sidecar_1.diveCrew.getAllFiltered(function (c) { return c.type === diveCrew_1.EVoyageCrewType.Pet; });
            deadHeroes = diveCrew_sidecar_1.diveCrew.getAllFiltered(function (c) { return c.type === diveCrew_1.EVoyageCrewType.Hero && diveCrew_sidecar_1.diveCrew.isDeadish(c); });
            console.log('existing heroes: ' + existingHeroes.length);
            getNextSpot = function () {
                var spot = possibleSpots.pop();
                assert_sidecar_1.assert.notNil(spot);
                var oi = spot[0];
                var oj = spot[1];
                return { oi: oi, oj: oj };
            };
            while (deadHeroes.length > 0) {
                c = deadHeroes.pop();
                assert_sidecar_1.assert.notNil(c);
                assert_sidecar_1.assert.notNil(c.heroState);
                diveMessage_alterEntity_sidecar_1.diveMessage_alterEntity.addToAfterLevelMessageQueue({
                    alterType: diveMessage_alterEntity_1.EDiveAlterType.CrewDestroy,
                    id: c.id,
                    i: 0,
                    j: 0,
                });
                continue;
            }
            while (existingHeroes.length > 0 && possibleSpots.length > 0) {
                c = existingHeroes.pop();
                assert_sidecar_1.assert.notNil(c);
                assert_sidecar_1.assert.notNil(c.heroState);
                c.isUpStairs = true;
                c.isDownStairs = false;
                _a = getNextSpot(), oi = _a.oi, oj = _a.oj;
                diveMessage_alterEntity_sidecar_1.diveMessage_alterEntity.addToAfterLevelMessageQueue({
                    alterType: diveMessage_alterEntity_1.EDiveAlterType.CrewEnterLevel,
                    id: c.id,
                    i: stairUp.i + oi,
                    j: stairUp.j + oj,
                });
            }
            while (existingPets.length > 0 && existingPets.length > 0) {
                c = existingPets.pop();
                assert_sidecar_1.assert.notNil(c);
                _b = getNextSpot(), oi = _b.oi, oj = _b.oj;
                diveMessage_alterEntity_sidecar_1.diveMessage_alterEntity.addToAfterLevelMessageQueue({
                    alterType: diveMessage_alterEntity_1.EDiveAlterType.CrewEnterLevel,
                    id: c.id,
                    i: stairUp.i + oi,
                    j: stairUp.j + oj,
                });
            }
            // Better be a staircase up...
            if (doCreateStuff) {
                heroIdx = 0;
                heroSubtypes = [
                    diveCrew_hero_data_1.EDiveHeroSubtype.Peasant,
                    // EDiveHeroSubtype.Soldier,
                    // EDiveHeroSubtype.Archer,
                    // EDiveHeroSubtype.Wizard,
                ];
                heroWeapons = [
                    diveObjectsData_1.EDiveObjectType.Null,
                    // EDiveObjectType.Weapon_Bow,
                    // EDiveObjectType.Weapon_Sword,
                    // EDiveObjectType.Weapon_Spellbook,
                    //EDiveObjectType
                ];
                if (diveDebug_sidecar_1.diveDebug.debug_startWithClasses) {
                    heroSubtypes = [
                        diveCrew_hero_data_1.EDiveHeroSubtype.Soldier,
                        diveCrew_hero_data_1.EDiveHeroSubtype.Archer,
                        diveCrew_hero_data_1.EDiveHeroSubtype.Wizard,
                        diveCrew_hero_data_1.EDiveHeroSubtype.Gunslinger,
                    ];
                    heroWeapons = [
                        diveObjectsData_1.EDiveObjectType.Weapon_Sword,
                        diveObjectsData_1.EDiveObjectType.Weapon_Bow,
                        diveObjectsData_1.EDiveObjectType.Weapon_Spellbook,
                        diveObjectsData_1.EDiveObjectType.Weapon_Pistols,
                    ];
                }
                while (numNewHeroes > 0 && possibleSpots.length > 0) {
                    numNewHeroes--;
                    _c = getNextSpot(), oi = _c.oi, oj = _c.oj;
                    heroType = heroSubtypes[heroIdx % heroSubtypes.length];
                    heroWeapon = heroWeapons[heroIdx % heroWeapons.length];
                    heroIdx++;
                    cr = diveCrew_sidecar_1.diveCrew.create(diveCrew_1.EVoyageCrewType.Hero, diveCrew_hero_data_1.EDiveHeroSubtype.Peasant, '', 0, 0);
                    diveCrew_sidecar_1.diveCrew.moveToIJ(cr, stairUp.i + oi, stairUp.j + oj);
                    //assert.notNil(cr.heroState)
                    //cr.heroState.isUpStairs = true
                    // Create our weapon
                    if (heroWeapon !== diveObjectsData_1.EDiveObjectType.Null) {
                        weapData = diveObjectsData_sidecar_1.diveObjectsData.find(heroWeapon);
                        assert_sidecar_1.assert.notNil(weapData);
                        weap = diveObjects_sidecar_1.diveObjects.create(0, weapData);
                        // Give this weapon to our hero
                        diveObjects_sidecar_1.diveObjects.do_pickup(cr, weap, false);
                    }
                    // voyageMessageCrewCreate.sendToAll({
                    //   crewId: createId(),
                    //   i: stairUp.i + oi,
                    //   j: stairUp.j + oj,
                    //   team: 0,
                    //   type: EVoyageCrewType.Hero,
                    //   heroType,
                    //   enemyType: '',
                    //   method: EVoyageCrewCreateMethod.Normal,
                    //   name: voyageFakeInfo.genFakeName(),
                    //   energy: 100,
                    //   hitpoints: 100,
                    // })
                }
                while (numNewPets > 0 && possibleSpots.length > 0) {
                    numNewPets--;
                    _d = getNextSpot(), oi = _d.oi, oj = _d.oj;
                    cr = diveCrew_sidecar_1.diveCrew.create(diveCrew_1.EVoyageCrewType.Pet, diveCrew_hero_data_1.EDiveHeroSubtype.None, '', 0, 0);
                    cr.name = 'Indie';
                    cr.hitpoints = 9999;
                    diveCrew_sidecar_1.diveCrew.moveToIJ(cr, stairUp.i + oi, stairUp.j + oj);
                    // voyageMessageCrewCreate.sendToAll({
                    //   crewId: createId(),
                    //   i: stairUp.i + oi,
                    //   j: stairUp.j + oj,
                    //   team: 0,
                    //   type: EVoyageCrewType.Pet,
                    //   heroType: EDiveHeroSubtype.None,
                    //   enemyType: '',
                    //   method: EVoyageCrewCreateMethod.Normal,
                    //   name: 'Indie',
                    //   energy: 100,
                    //   hitpoints: 100,
                    // })
                }
                enemySubtypes = [
                    'rat',
                    // 'zombie',
                    // 'slime',
                    // 'goblin-warrior',
                    // 'skeleton-warrior',
                    // 'necromancer',
                ] // ['goblin-warrior', 'rat', 'slime', 'zombie]
                ;
                if (info.options.levelNum > 1) {
                    enemySubtypes.push('zombie');
                }
                if (info.options.levelNum > 2) {
                    enemySubtypes.push('slime');
                }
                if (info.options.levelNum > 3) {
                    enemySubtypes.push('goblin-warrior');
                }
                if (info.options.levelNum > 4) {
                    enemySubtypes.push('skeleton-warrior');
                    enemySubtypes.push('necromancer');
                }
                if (info.options.levelNum > 5) {
                    enemySubtypes = []; // Clear
                    // Spider level
                    enemySubtypes.push('spider-queen');
                    enemySubtypes.push('spider-large');
                    enemySubtypes.push('spider-mini');
                }
                if (diveDebug_sidecar_1.diveDebug.debug_doDebugMonster) {
                    enemySubtypes = [];
                    enemySubtypes.push.apply(enemySubtypes, __spreadArray([], __read(diveDebug_sidecar_1.diveDebug.debug_monsterTypes)));
                }
                if (!info.options.isSafeRoom) {
                    enemiesMultiplier = 1 + info.options.levelNum * 0.33;
                    numEnemies = Math.round(10 * enemiesMultiplier);
                    if (diveDebug_sidecar_1.diveDebug.debug_noEnemies) {
                        numEnemies = 0;
                    }
                    iAttempts = 500;
                    freeSpots = genUtils_sidecar_1.genUtils.tilemapCollectFreeSpots();
                    while (numEnemies && iAttempts && freeSpots.length > 0) {
                        iAttempts--;
                        freeSpot = rnd.sampleAndRemove(freeSpots);
                        distFromSafeZone = distanceUtil_sidecar_1.distanceUtil.distanceSimpleIIJ(freeSpot, stairUp);
                        if (distFromSafeZone < 8) {
                            continue;
                        }
                        cr = diveCrew_sidecar_1.diveCrew.create(diveCrew_1.EVoyageCrewType.Enemy, diveCrew_hero_data_1.EDiveHeroSubtype.None, rnd.sample(enemySubtypes), 0, 0);
                        diveCrew_sidecar_1.diveCrew.moveToIJ(cr, freeSpot.i, freeSpot.j);
                        // voyageMessageCrewCreate.sendToAll({
                        //   crewId: createId(),
                        //   i: freeSpot.i,
                        //   j: freeSpot.j,
                        //   team: 0,
                        //   type: EVoyageCrewType.Enemy,
                        //   heroType: EDiveHeroSubtype.None,
                        //   enemyType: rnd.sample(enemySubtypes),
                        //   method: EVoyageCrewCreateMethod.Normal,
                        //   // TODO: replace this with generator based on type
                        //   name: 'Goblin', //voyageFakeInfo.genFakeName(),
                        //   energy: 100,
                        //   hitpoints: 100,
                        // })
                        numEnemies--;
                    }
                }
            }
        }
        return [2 /*return*/];
    });
}
exports.gen_add_monsters = gen_add_monsters;
